import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DatabaseBackup, Download } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { downloadMyData } from "../../api/dataExport";

// تنزيل نسخة كاملة من بيانات الموظف بملف واحد (GDPR م.15 و م.20).
export const MyDataExportCard = () => {
  const { t, i18n } = useTranslation();
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await downloadMyData(i18n.language);
      toast.success(t("dataExport.done"));
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard data-testid="my-data-export-card">
      <div className="flex items-start justify-between gap-3">
        <p className="label-xs">{t("dataExport.title")}</p>
        <DatabaseBackup className="h-5 w-5 text-primary" />
      </div>
      <p className="mt-3 text-xs leading-6 text-muted-foreground">{t("dataExport.hint")}</p>
      <NeuButton variant="primary" className="mt-4 flex w-full items-center justify-center gap-2 py-3 sm:w-auto sm:px-6"
        data-testid="my-data-export-btn" disabled={busy} onClick={run}>
        <Download className="h-4 w-4" /> {busy ? t("dataExport.busy") : t("dataExport.action")}
      </NeuButton>
    </NeuCard>
  );
};
